import { MarketoProgramObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type ProgramCreationResponse = {
    result: string;
}

type UseProgramCreationResponse = [
    (data: MarketoProgramObject) => Promise<ProgramCreationResponse | null>,
    {
        value?: ProgramCreationResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useCreateNewProgram = (): UseProgramCreationResponse => {
    
    const [post, postState] = usePost<ProgramCreationResponse, MarketoProgramObject>({
        url: `settings/create-program`
    })

    const createProgram = async (
        data : MarketoProgramObject
    ) : Promise<ProgramCreationResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [createProgram, postState];
};